module.exports = __webpack_public_path__ + "39084d893bcc8f6624d1c15531c5397f.png";